var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{class:{ 'red': _vm.setIcon == 'ExclamationCircle', 'green': _vm.setIcon == 'CheckCircle', 'gray': _vm.setIcon == 'MinusCircle' },attrs:{"iconName":_vm.setIcon,"iconType":_vm.iconType}})}
var staticRenderFns = []

export { render, staticRenderFns }